import React, { useEffect, useState } from 'react';
import { Box, Typography, Dialog, IconButton, Grid } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { makeStyles } from '@mui/styles';
import Loading from '../../Loading';
import { getTransfersInventory } from '../../../apis/product';
import CustomButton from '../../UI/CustomButton';
import useStyles from './useStyles';

const useStyle = makeStyles(() => ({
  paper: {
    borderRadius: '1rem',
    direction: 'rtl',
  },
}));

interface InfoKnowledgeDialogProps {
  openTransfersProduct: boolean;
  closeDialog: () => void;
  setTransferCode: (transferCode: string) => void;
  setOpenUsersUsedProduct: (open: boolean) => void;
}

const TransfersProduct: React.FC<InfoKnowledgeDialogProps> = (props) => {
  const { openTransfersProduct, closeDialog, setTransferCode, setOpenUsersUsedProduct } = props;
  const styles = useStyle();
  const classes = useStyles();

  const [transfersList, setTransfersList] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => closeDialog();

  const getTransfersProductData = () => {
    setLoading(true);
    getTransfersInventory()
      .then((res: any) => setTransfersList(res || []))
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (openTransfersProduct) getTransfersProductData();
  }, [openTransfersProduct]);

  return (
    <Dialog
      onClose={handleClose}
      open={openTransfersProduct}
      maxWidth='xl'
      classes={{ paper: styles.paper }}
    >
      <Box className={classes.mainDialog}>
        <Box className={classes.header}>
          <Typography color='text.main' fontWeight='bold'>
            لیست انتقالی ها
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseRoundedIcon color='action' />
          </IconButton>
        </Box>

        <Box mb={2} mt={1}>
          {loading ? (
            <Loading fullHeight={false} />
          ) : (
            <Grid container spacing={2}>
              {transfersList?.map((item: any) => (
                <Grid item lg={3} key={item.id}>
                  <Box className={classes.cardContainer}>
                    <Typography color='text.main' fontWeight='bold'>
                      {item.productName}
                    </Typography>

                    <Box className='spaceBetween' my={0.5}>
                      <Typography color='text.light' fontSize='small'>
                        تعداد انتقالی:
                      </Typography>
                      <Typography fontSize='small'>{item.transferCount}</Typography>
                    </Box>

                    <Box className='spaceBetween' my={0.5}>
                      <Typography color='text.light' fontSize='small'>
                        تاریخ:
                      </Typography>
                      <Typography dir='ltr' fontSize='small'>
                        {item.latestTransactionDate}
                      </Typography>
                    </Box>

                    <Box mt={1} width='100%'>
                      <CustomButton
                        fullWidth
                        onClick={() => {
                          setTransferCode(item.transferCode);
                          setOpenUsersUsedProduct(true);
                          handleClose();
                        }}
                      >
                        لیست کاربرها
                      </CustomButton>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default TransfersProduct;
